import { createAsyncThunk } from '@reduxjs/toolkit';
import { getHomepageService } from './homeService';

export const getHomepage = createAsyncThunk(
  'home/get',
  async (platform, { rejectWithValue }) => {
    try {
      const response = await getHomepageService(platform);
      if (response.status) {
        return response.data; // Homepage data is in response.data (normalized from .response)
      }
      return rejectWithValue(response.message || 'Failed to fetch homepage');
    } catch (error) {
      return rejectWithValue(error.message || 'Network error');
    }
  }
);
